// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-d4d71398]{display:flex;min-height:100vh;flex-direction:column;padding-top:88px}@media screen and (max-width: 960px){.layout[data-v-d4d71398]{padding-top:64px}}.layout__main[data-v-d4d71398]{flex:1;display:flex;position:relative;background:#1c0c32;flex-direction:column}.layout__main[data-v-d4d71398]:before{left:0;right:0;top:-80px;content:'';height:80px;position:absolute;background:#1c0c32}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
